// removed by extract-text-webpack-plugin
module.exports = {"button":"StyledButton__button___DK62r","inverted":"StyledButton__inverted___2uYEL","link":"StyledButton__link___2rexs"};